export default __webpack_public_path__ + "static/media/topimg.055a9e3c.png";